import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Sidebar from 'components/Sidebar';
import MobileHeader from 'components/MobileHeader';
import SearchOverlay from 'components/SearchOverlay';
import Container from 'components/Container';
import { CaretLeftIcon } from '@phosphor-icons/react';
import { useQuery } from '@tanstack/react-query';
import LoadingOverlay from 'components/LoadingOverlay';

import { getAssistants } from 'api/assistants';

export default function List() {

    const [sidebar, setSidebar] = useState(false);
    const [search, setSearch] = useState(false);

    const { data: assistants, isLoading } = useQuery({
        queryKey: ['assistants'],
        queryFn: async () => await getAssistants({}),
    });
    return (
        <>
            <Sidebar
                visible={sidebar}
                setVisible={setSidebar}
            />

            <SearchOverlay
                visible={search}
                setVisible={setSearch}
            />

            <MobileHeader
                sidebar={sidebar}
                setSidebar={setSidebar}
                search={search}
                setSearch={setSearch}
            />

            <LoadingOverlay isLoading={isLoading} />

            <div className={`fixed top-0 w-full bottom-0 transition-all duration-300 ease-in-out lg:pl-[320px] overflow-y-auto ${sidebar ? 'left-[80vw]' : 'left-0'}`}>
                <Container>
                    <div className='flex gap-3 items-center pb-8 pt-20 md:pt-14'>
                        <div className='flex-1 flex items-center gap-3'>
                            <Link to="/settings" className=''>
                                <CaretLeftIcon size={26} className='text-black hover:text-muted' />
                            </Link>
                            <p className='text-3xl'>Assistenti</p>
                        </div>
                        <Link to="/settings/assistants/create" className='bg-black font-medium cursor-pointer text-white px-4 py-3 text-sm rounded-sm hover:bg-greydark'>
                            Crea nuovo Assistente
                        </Link>
                    </div>

                    <div className=''>
                        <div className='border border-light rounded-sm mt-6 overflow-hidden'>
                            {assistants?.map((assistant, index) => {
                                return (
                                    <Link to={`/settings/assistants/${assistant._id}`} key={index} className='border-b last:border-0 border-light hover:bg-verylight flex items-center gap-4 p-4'>
                                        <div className='flex-1'>
                                            <p className='font-semibold'>{assistant.name}</p>
                                        </div>
                                        <div className='flex-1'>
                                            <p className='text-muted'>{assistant.code}</p>
                                        </div>
                                    </Link>
                                )
                            })}
                        </div>
                    </div>
                </Container>
            </div>
        </>
    )
}
